import React from "react";
import Card from "react-bootstrap/Card";
import { useIntl } from "react-intl";

import SoftwarePackages from "./SoftwarePackages";

const messages = {
  softwarePackages: {
    id: "modules.SoftwarePackage.components.Dashboard.softwarePackages",
    description: "ICT News - Applicaties label.",
    defaultMessage: "ICT News - Applicaties",
  },
};

const Dashboard = () => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {formatMessage(messages.softwarePackages)}
      </Card.Header>
      <Card.Body>
        <SoftwarePackages />
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
